import methods from "../Service";
import useHttpParamsJsonCreate from "hooks/useHttpParamsJsonCreate";
const useParamsJson = (param) => { return useHttpParamsJsonCreate(param); }
const PuntoEmision = {
    async Get() { return await methods.Get("PuntoEmision/Get") },
    async List(qs) { return await methods.Get("PuntoEmisionSucursal/List" + useParamsJson(qs)) },

    async ListGet() { return await methods.Get("PuntoEmision/ListGet") },
    async ListGetByRol(qs) { return await methods.Get("PuntoEmision/ListGetByRol" + useParamsJson(qs) ) },
    async ListGetByUser(qs) { return await methods.Get("PuntoEmision/ListGetByUser" + useParamsJson(qs) ) },
    async Post(data) { return await methods.Post("PuntoEmision/Post", data) },
    async Put(qs, data) { return await methods.Put("PuntoEmision/Put" + useParamsJson(qs), data) },
    async Delete(qs) { return await methods.Delete("PuntoEmision/Delete" + useParamsJson(qs)) },
    async Verifica(qs) { return await methods.Get("PuntoEmision/Verifica" + useParamsJson(qs)) }

};

export default PuntoEmision;